import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { RouterHistory } from 'react-router';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { CheckCircleOutlineRounded } from '@material-ui/icons';
import { compose } from '../../utility';
import styles from './feedback.styles';
import Button from '../../shared/button/button';
import { withAppUser } from '../../shared/authorization/userConsumer';
import { messages } from './constants';
import { removeSession } from '../../util/removeSession';

type PropType = {
  classes: Object,
  history: RouterHistory,
  isCurrentUserSoleSignee: boolean,
};

class FeedbackC extends React.PureComponent<PropType, null> {
  handleClick = () => {
    this.props.history.push('/agent/sessions');
  };

  componentDidMount() {
    removeSession();
  }

  render() {
    const { classes, isCurrentUserSoleSignee } = this.props;
    return (
      <div className={classes.landing}>
        <Helmet
          titleTemplate="%s - RealDesk Esign"
          defaultTitle="RealDesk Esign"
        >
          <meta name="description" content="Agent Panel" />
          <title>New Session</title>
        </Helmet>
        <div className={classes.view}>
          <AppBar classes={{ root: classes.root }} elevation={0}>
            <p className={classes.screenTitle}>{messages.CONFIRMATION}</p>
          </AppBar>
          <div className={classes.viewContent}>
            <Card className={classes.card}>
              <CheckCircleOutlineRounded className={classes.screenIcon} />
              <div className={classes.titleContainer}>
                <div className={classes.cardTitle}>
                  {isCurrentUserSoleSignee
                    ? messages.DOCUMENTS_COMPLETED
                    : messages.DOCUMENTS_SENT}
                </div>
              </div>
              <CardContent className={classes.cardContent}>
                <div>
                  {isCurrentUserSoleSignee
                    ? messages.DOCUMENTS_COMPLETED_NOTICE
                    : messages.DOCUMENTS_SENT_FOR_SIGNING}
                </div>
              </CardContent>
              <CardActions className={classes.button}>
                <Button
                  color="primary"
                  disableFocusRipple
                  onClick={this.handleClick}
                >
                  {messages.VIEW_SIGNING_SESSIONS}
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  withAppUser
)(FeedbackC);
